import React, { useState, useEffect } from "react"
import { StaticImage } from "gatsby-plugin-image"

import { useShowModal, useDismissModal } from "../states/context/ModalContext"
import useAuth from "../states/context/AuthContext"
import FormInput from "../components/inputs/FormInput"
import useInput from "../utils/hooks/useInput"
import FormButton from "../components/buttons/FormButton"
import CloseButton from "../components/buttons/CloseButton"

import {
  Wrapper,
  Container,
  TextContainer,
  Logo,
  Title,
  Title2,
  Caption,
  FormContainer,
  InputContainer,
  ButtonContainer,
  CloseButtonContainer,
} from "./SignInModal"
import ErrorBubble from "../components/other/ErrorBubble"

const SignUpModal = () => {
  const showSignInModal = useShowModal("signIn")
  const dismiss = useDismissModal()
  const { signUpWithPassword, status } = useAuth()

  const { value: email, bind: bindEmail } = useInput("")
  const { value: password, bind: bindPassword } = useInput("")
  const [error, setError] = useState("")

  const handleSignUpWithPassword = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    signUpWithPassword(email, password)
  }

  if (status.isResolved) {
    dismiss()
  }

  useEffect(() => {
    if (status.isRejected) {
      status.error && setError(status.error)
    }
  }, [status])

  return (
    <Wrapper>
      <CloseButtonContainer>
        <CloseButton />
      </CloseButtonContainer>
      {error !== "" && <ErrorBubble error={error} />}
      <Container>
        <Logo src="/images/logos/logo.svg" alt="angle logo" />
        <StaticImage
          className="illustration"
          src="../images/illustrations/illustration1.webp"
          alt="illustration"
        />
        <Title>Sign Up</Title>
      </Container>
      <FormContainer onSubmit={handleSignUpWithPassword}>
        <InputContainer>
          <Title2>Email address</Title2>
          <FormInput
            name="email"
            type="email"
            placeholder="Email address"
            icon="/images/icons/envelope.svg"
            autoComplete="on"
            required
            {...bindEmail}
          />
        </InputContainer>
        <InputContainer>
          <Title2>Password</Title2>
          <FormInput
            name="password"
            type="password"
            placeholder="Password"
            icon="/images/icons/password.svg"
            autoComplete="on"
            {...bindPassword}
            required
          />
        </InputContainer>
        <ButtonContainer>
          <FormButton
            title="Sign up"
            type="submit"
            isLoading={status.isPending}
            disabled={status.isPending}
          />
        </ButtonContainer>
      </FormContainer>
      <TextContainer>
        <Caption>
          Already have an account? <span onClick={showSignInModal}>Sign in</span>
        </Caption>
      </TextContainer>
    </Wrapper>
  )
}

export default SignUpModal
